import gql from 'graphql-tag';

const getRacetrackAnalyticsQuery = gql`
  query GetRacetrackAnalytics(
    $organisationId: String!
    $createdAt: [String],
    $orderBy: String,
    $orderByDirection: String
  ) {
    getRacetrackAnalytics(
      organisationId: $organisationId,
      createdAt: $createdAt,
      orderBy: $orderBy,
      orderByDirection: $orderByDirection
    ) {
      racetrackData {
        createdByUserId
        numberOfVideos
        firstName
        lastName
        imageUrl
        totalVideosAndEngagements
      }
      userData {
        createdByUserId
        numberOfVideos
        firstName
        lastName
        imageUrl
        totalVideosAndEngagements
      }
    }
  }
`;

const queryGetRacetrackAnalytics = (
organisationId) => (
{
  query: getRacetrackAnalyticsQuery,
  module: 'analytics',
  buildVariables: (data) => {
    const {
      createdAt,
      orderBy,
      orderByDirection
    } = data;

    return {
      createdAt,
      organisationId,
      orderBy,
      orderByDirection
    };
  }
});

export default queryGetRacetrackAnalytics;